import React, { Component } from 'react'
import { Field, ErrorMessage, getIn, FieldArray } from 'formik'
import { Dropdown } from 'semantic-ui-react'
import ErrorPopUp from '../../Shared/ErrorPopUp'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>اطلاعات تکمیلی</legend>

          <div className="row">
            <div className="form-inline">
              <FieldArray
                name="infos"
                render={arrayHelpers => (
                  <div>
                    {values?.infos?.map((item, index) => (
                      <div className="col-md-2 col-sm-12">
                        {item.fieldType === 0 ? (
                          <>
                            <label>{item.name}</label>
                            <Field
                              name={`infos[${index}].value`}
                              className={
                                errors?.infos?.[index]?.value
                                  ? 'text-input has-error'
                                  : 'text-input'
                              }
                            />
                            {errors?.infos?.[index]?.value && item.required ? (
                              <ErrorPopUp
                                error="فیلد الزامی"
                                type="fullText"
                                touched
                              />
                            ) : (
                              ''
                            )}
                          </>
                        ) : item.fieldType === 2 ? (
                          <>
                            <label>{item.name}</label>
                            <YesNoSelect
                              // defaultValue={values.shift}
                              onChange={val => {
                                setFieldValue(`infos[${index}].value`, val)
                              }}
                              className={
                                errors?.infos?.[index]?.value
                                  ? 'semantic-select-box has-error'
                                  : 'semantic-select-box'
                              }
                            />
                            {errors?.infos?.[index]?.value && item.required ? (
                              <ErrorPopUp
                                error="فیلد الزامی"
                                type="fullText"
                                touched
                              />
                            ) : (
                              ''
                            )}
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                    ))}
                  </div>
                )}
              />
            </div>
          </div>
        </fieldset>
        {/* <ErrorMessage component={ErrorPopUp} name="infos" /> */}
      </div>
    </div>
  </>
)

const yesNoFields = [
  { text: 'دارد', value: '1' },
  { text: 'ندارد', value: '2' }
]
export class YesNoSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      selectedValue: this.props.defaultValue
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.selectedValue) {
      this.setState({ selectedValue: nextProps.defaultValue })
    }
  }

  handleChange = e => {
    let selected = e
    this.setState({ selectedValue: selected })
    this.props.onChange(selected)
  }

  render() {
    const { loading, defaultValue, disabled } = this.state
    const { clearable, className } = this.props

    return (
      <Dropdown
        placeholder=""
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className={className}
        options={yesNoFields}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    )
  }
}
